export function getdata() {
	var obj = {
		searchlist: [{
				prop: "nsrmc",
				label: '纳税人名称',
				type: "input"
			},
			{
				prop: "nsrsbh",
				label: '纳税人识别号',
				type: "input"
			},
			{
				prop: "mingxts",
				label: '明细条数',
				type: "inputplus"
			},
			{
				prop: "ybtsehj",
				label: '应补(退)税额合计',
				type: "inputplus",
			},
		],
		searchdata: {
			nsrmc: "",
			nsrsbh: "",
			mingxts: [],
			ybtsehj: [],
		},
		headData: [{
				title: "纳税人名称",
				prop: "nsrmc",
				custom: true,
				width: 160,
			},
			{
				title: "纳税人识别号",
				prop: "nsrsbh",
				custom: true,
				width: 160,
			},
			{
				title: "应补（退）税额合计",
				prop: "ybtsehj",
				width: "160",
				custom: true,
				AmountFormat:true,
			},
			{
				title: "明细条数",
				prop: "mingxts",
				custom: true,
				width: "80",
			},
			{
				title: "操作",
				prop: "cz",
				custom: true,
				width: "200"
			},
		],
		pagination: {
			pageNum: 1,
			pageSize: 50,
			total: 0,
			paginationkey: 0
		},
		tabjson: "{  \"searchList\":[    {      \"name\":\"纳税人名称\",      \"column\":\"nsrmc\",      \"originName\":\"纳税人名称\",      \"show\":\"0\"    },    {      \"name\":\"纳税人识别号\",      \"column\":\"nsrsbh\",      \"originName\":\"纳税人识别号\",      \"show\":\"0\"    },    {      \"name\":\"应补（退）税额合计\",      \"column\":\"ybtsehj\",      \"originName\":\"应补（退）税额合计\",      \"show\":\"0\"    },    {      \"name\":\"明细条数\",      \"column\":\"mingxts\",      \"originName\":\"明细条数\",      \"show\":\"0\"    },    {      \"name\":\"数据来源\",      \"column\":\"shujly\",      \"originName\":\"数据来源\",      \"show\":\"0\"    },    {      \"name\":\"修改时间\",      \"column\":\"updateTime\",      \"originName\":\"修改时间\",      \"show\":\"0\"    },    {      \"name\":\"修改人\",      \"column\":\"updateBy\",      \"originName\":\"修改人\",      \"show\":\"0\"    }  ],  \"headData\":[    {      \"name\":\"纳税人名称\",      \"column\":\"nsrmc\",      \"originName\":\"纳税人名称\",      \"show\":\"0\"    },    {      \"name\":\"纳税人识别号\",      \"column\":\"nsrsbh\",      \"originName\":\"纳税人识别号\",      \"show\":\"0\"    },    {      \"name\":\"应补（退）税额合计\",      \"column\":\"ybtsehj\",      \"originName\":\"应补（退）税额合计\",      \"show\":\"0\"    },    {      \"name\":\"明细条数\",      \"column\":\"mingxts\",      \"originName\":\"明细条数\",      \"show\":\"0\"    },    {      \"name\":\"数据来源\",      \"column\":\"shujly\",      \"originName\":\"数据来源\",      \"show\":\"0\"    },    {      \"name\":\"修改时间\",      \"column\":\"updateTime\",      \"originName\":\"修改时间\",      \"show\":\"0\"    },    {      \"name\":\"修改人\",      \"column\":\"updateBy\",      \"originName\":\"修改人\",      \"show\":\"0\"    }  ],  \"formlist\":[    {      \"name\":\"纳税人名称\",      \"column\":\"nsrmc\",      \"originName\":\"纳税人名称\",      \"show\":\"0\"    },    {      \"name\":\"纳税人识别号\",      \"column\":\"nsrsbh\",      \"originName\":\"纳税人识别号\",      \"show\":\"0\"    },    {      \"name\":\"应补（退）税额合计\",      \"column\":\"ybtsehj\",      \"originName\":\"应补（退）税额合计\",      \"show\":\"0\"    },    {      \"name\":\"明细条数\",      \"column\":\"mingxts\",      \"originName\":\"明细条数\",      \"show\":\"0\"    },    {      \"name\":\"数据来源\",      \"column\":\"shujly\",      \"originName\":\"数据来源\",      \"show\":\"0\"    },    {      \"name\":\"修改时间\",      \"column\":\"updateTime\",      \"originName\":\"修改时间\",      \"show\":\"0\"    },    {      \"name\":\"修改人\",      \"column\":\"updateBy\",      \"originName\":\"修改人\",      \"show\":\"0\"    }  ]}"
	}
	return obj
}
